import routesLimited from '@/constants/routesLimited'
import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { RouteRecordRaw } from 'vue-router'
import { aliases } from '../aliases'

const document: RouteRecordRaw = {
	component: () => import('components/modules/Documents/Document.vue'),
	meta: {
		nav: false,
		title: 'entity.document.name',
		validateItem: true,
	},
	name: 'document',
	path: '/documents/:id',
	alias: aliases.document,
	props: castRouteIds,
}
const documents: RouteRecordRaw = {
	children: [document],
	component: () => import('components/modules/Documents/List.vue'),
	name: 'documents',
	path: '/documents',
	meta: {
		breadcrump: 'routeTitle.documentsList',
		title: 'common.list',
		icon: 'fa-fw fas fa-file',
		offline: true,
		auth: true,
		nav: true,
		subs: [routesLimited.subModules.documents],
	},
}
const documenttypes: RouteRecordRaw = {
	component: () => import('components/modules/Documents/Types.vue'),
	name: 'documenttypes',
	path: '/documenttypes',
	meta: {
		offline: true,
		breadcrump: 'routeTitle.documentsGroup',
		title: 'common.group',
		icon: 'fa-fw fas fa-book',
		auth: true,
		nav: true,
	},
}
const documentsGroup: RouteRecordRaw = {
	children: [documents, documenttypes],
	component: () => import('components/modules/PassThrough.vue'),
	meta: {
		offline: true,
		title: 'routeTitle.documents',
		icon: 'fa-fw fa-solid fa-files',
		auth: true,
		nav: true,
		tour: true,
		ordering: 1,
	},
	name: 'documents_group',
	path: '/documents_group',
	redirect: { name: 'documents' },
}

export const documentsGroupRoutes: RouteRecordRaw[] = [
	documentsGroup,
	documents,
	documenttypes,
	document,
]

export { documentsGroup }
